import { Checkbox, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import {
  IWithWorksheetInjectedProps,
  WorksheetResultsSection,
  WorksheetsResultsMessagesSection,
} from 'Components/Worksheets/Core';
import { hasValue, valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

const contextCaptions = [
  { path: `data.LiquidLimit.Trials`, caption: 'Liquid Limit' },
  { path: `data.PlasticLimit.Trials`, caption: 'Plastic Limit' },
  { path: `data.Preparation.AssociatedAsReceivedWaterContent`, caption: 'As-Received Moisture Content' },
];

let ResultsSectionWithShrinkage: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const reportWeightedPlasticityIndex = useSelector(
    createWorksheetSelector!('Results.ReportWeightedPlasticityIndex')
  ) as boolean;
  const LinearShrinkageText = useSelector(pipe(createWorksheetSelector!('Results.LinearShrinkageText'), hasValue));
  const llNonPlastic = useSelector(pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false)));
  const plNonPlastic = useSelector(pipe(createWorksheetSelector!('PlasticLimit.NonPlastic'), valueOrDefault(false)));
  const plasticityIndexText = useSelector(
    pipe(createWorksheetSelector!('Results.WeightedPlasticityIndexText'), hasValue)
  );

  return (
    <WorksheetResultsSection heading="Results">
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />
      <ListFieldSection heading="Results">
        <Field input={<TextOutput />} name="Results.LiquidLimitText" visible={llNonPlastic} />
        <Field input={<TextOutput />} name="Results.LiquidLimit" visible={!llNonPlastic} />
        <Field input={<TextOutput />} name="Results.PlasticLimitText" />
        {llNonPlastic || plNonPlastic ? (
          <Field input={<TextOutput />} name="Results.PlasticityIndexText" />
        ) : (
          <Field input={<TextOutput />} name="Results.PlasticityIndex" />
        )}
        <Field input={<TextOutput />} name="Results.LinearShrinkage" visible={!LinearShrinkageText} />
        <Field input={<TextOutput />} name="Results.LinearShrinkageText" visible={LinearShrinkageText} />
        <Field input={<TextOutput />} name="Results.Sieve_0_425" visible={reportWeightedPlasticityIndex} />
        <Field
          input={<TextOutput />}
          name="Results.WeightedPlasticityIndexText"
          visible={reportWeightedPlasticityIndex && plasticityIndexText}
        />
        <Field
          input={<TextOutput />}
          name="Results.WeightedPlasticityIndex"
          visible={reportWeightedPlasticityIndex && !plasticityIndexText}
        />
      </ListFieldSection>
      <ListFieldSection heading="Optional Reporting">
        <Field input={<Checkbox />} name="Results.ReportWeightedPlasticityIndex" />
      </ListFieldSection>
    </WorksheetResultsSection>
  );
};

ResultsSectionWithShrinkage = withInjectedProps(ResultsSectionWithShrinkage);

export { ResultsSectionWithShrinkage };
export default ResultsSectionWithShrinkage;
